"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyIcon = EmptyIcon;
exports.Empty = Empty;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _core = require("@blueprintjs/core");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function EmptyIcon(_ref) {
  var strokeOverride = _ref.stroke;
  var stroke = strokeOverride || _index.Colors.IVORY_20;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '122px',
      height: '122px',
      border: "1px solid ".concat(stroke)
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement(_index.Icon60, {
    icon: _index.IconNames60.CROSS,
    stroke: stroke
  }), /*#__PURE__*/React.createElement(_index.Icon60, {
    icon: _index.IconNames60.RAINBOW,
    stroke: stroke
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement(_index.Icon60, {
    icon: _index.IconNames60.TARGET,
    stroke: stroke
  }), /*#__PURE__*/React.createElement(_index.Icon60, {
    icon: _index.IconNames60.FLOWER,
    stroke: stroke
  })));
}

function Empty(_ref2) {
  var children = _ref2.children,
      compact = _ref2.compact,
      text = _ref2.text;
  var description = typeof text === 'string' ? /*#__PURE__*/React.createElement(_index.Lead, {
    muted: true
  }, text) : text;
  return /*#__PURE__*/React.createElement(_index.Card, {
    level: _index.CardLevel.FILLED
  }, /*#__PURE__*/React.createElement(_core.NonIdealState, {
    icon: compact ? false : /*#__PURE__*/React.createElement(EmptyIcon, null),
    description: description,
    action: /*#__PURE__*/React.createElement(React.Fragment, null, children)
  }));
}